export function HarriIconSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/harri-icon.svg'"></ng-include>`
    }
}
            